import { FC } from 'react'
import formatPhone from 'helpers/formatPhone'
import { Driver, LogisticsKRTrip } from 'views/pages/LogisticsKR/types'
import { TableExternalLink } from 'views/ui/TableTextLink/TableTextLink'
import { FlexColumnWrapper, SecondaryText } from '../styled'
import { DASH } from 'modules/constants'
import { useTranslation } from 'react-i18next'

export interface Props {
  driver: Driver | null
  trip: LogisticsKRTrip
}

export const DriverCell: FC<Props> = ({ driver, trip }) => {
  const { t } = useTranslation('logisticsKR')
  const { brand_model, licence_number } = trip.car || {}
  return (
    <FlexColumnWrapper>
      <div>{driver?.name ? driver.name : DASH}</div>
      {driver?.phone ? (
        <TableExternalLink href={`tel:${driver.phone}`}>{formatPhone(driver.phone)}</TableExternalLink>
      ) : (
        DASH
      )}
      <SecondaryText>{`${brand_model}/${licence_number}`}</SecondaryText>
      {!!trip.quantity_logistics && (
        <SecondaryText>
          {t('trips.details.quantity_logistics')} {trip.quantity_logistics} {t('common:ton')}
        </SecondaryText>
      )}
    </FlexColumnWrapper>
  )
}
